export default __webpack_public_path__ + "static/kosmetologi3-fb61041b66e70de3423b6436984040e5.jpg";